import React from "react"
import classnames from "classnames"
import { string, object, node, bool } from "prop-types"

import ThemeConsumer from "../ThemeConsumer"
import DefaultContainer from "../DefaultContainer"
import Typograph from "../../../components/Typograph"

const EmptyState = ({
  theme,
  children,
  title,
  description,
  icon,
  isContainer = true,
  showTitle = true,
  containerTitle,
  classNames
}) => {
  const iconClass = classnames(theme.icon, {
    [theme.resizeIcon]: children || title
  })
  return isContainer ? (
    <DefaultContainer>
      {showTitle && (
        <Typograph
          htmlTag="h2"
          preset="h2"
          size="medium"
          color="outer_space"
          weight="bold"
          classNames={theme.containerTitle}
        >
          {containerTitle}
        </Typograph>
      )}
      <div className={theme.emptyWrapper}>
        <img src={icon} alt="" className={iconClass} />
        <div>
          {title && <h3 className={theme.title}>{title}</h3>}
          <p className={theme.description}>{description}</p>
          {children}
        </div>
      </div>
    </DefaultContainer>
  ) : (
    <div className={classnames(theme.emptyWrapperNoContainer, classNames)}>
      <img src={icon} alt="" className={iconClass} />
      <div>
        {title && <h2 className={theme.title}>{title}</h2>}
        <p className={theme.description}>{description}</p>
        {children}
      </div>
    </div>
  )
}

EmptyState.propTypes = {
  children: node,
  containerTitle: string,
  title: string,
  description: string.isRequired,
  icon: string.isRequired,
  isContainer: bool,
  theme: object,
  classNames: string,
  showTitle: bool
}

EmptyState.defaultProps = {
  children: null,
  title: null,
  theme: {},
  description: "",
  showTitle: true
}

export default ThemeConsumer("UIEmptyState")(EmptyState)



// WEBPACK FOOTER //
// ./src/shared/components/EmptyState/index.js